export default {
  /**
   *@desc: 数组中含有对象，判断值在不在数组的对象中
   * @param {any[]} arr
   * @param {string} key
   * @param {(string | number)} value
   * @return { boolean} 结果 
   */
  arrIsKey (arr: any[], key: string, value: string | number) {
    let result = false
    result = arr.some((item: any) => { if(item[key]==value){ return true } })
    return result
  },
  // 处理所有不用token的请求
  // 正常接口 结尾
  _NOTTOKENURL:['oauth/token', 'loginByLdap', 'loginByTokenId', 'register',
  'autoLogin', 'profile-info', 'wxConfig', 'tagLanguage', 'config/images', 'license/validate', 'loginByMobile',
  'config/version', 'config/language', 'sms/code', 'sms/empPass', 'sms/validation',
  'nebulogyConfigObj/page', 'api/employeeScopeCheck','api/sys/SysTenant/list','api/sso/login',
   'api/ding-talk-Login'],
  // 接口开头包含
  _NOTTOKENURLFIRST:['/api/config/initial/', '/api/file/download/', '/api/upload/', '/api/last/licenseObj'],
  // 免Token放行
  requestIsNotToken(url:string) {
    let isNotToken = false;
    for (let i = 0; i < this._NOTTOKENURL.length; i++) {
      if (url.endsWith(this._NOTTOKENURL[i])) {
        isNotToken = true;
        break;
      }
    }
    for (let j = 0; j < this._NOTTOKENURLFIRST.length; j++) {
      if (url.indexOf(this._NOTTOKENURLFIRST[j]) > -1) {
        isNotToken = true;
        break;
      }
    }
    return isNotToken;
  }
}